const DEFAULT_CLASSNAMES = {
  container:
    "font-ubuntuRegular h-[150px] w-[300px] backdrop-blur-sm z-40 right-full top-1/3 absolute flex flex-col justify-center bg-greenGlass rounded-lg p-2",
};

const Popover = ({ classNames = DEFAULT_CLASSNAMES, children }) => {
  return (
    <div className={classNames?.container || DEFAULT_CLASSNAMES.container}>
      {children}
    </div>
  );
};

export default Popover;
